import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import './model.css';

export default function ProductDetailImageGallery(showImageUrls) {
    // console.log("ProductDetailImageGallery", showImageUrls)
    const [clickedImg, setClickedImg] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [currentImageList, setCurrentImageList] = useState([]);

    useEffect(() => {
        setCurrentImageList(showImageUrls.showImageUrls);
        // console.log("ProductDetailImageGallery", currentImageList)
    }, [showImageUrls.showImageUrls]);

    const handleClick = (item, index) => {
        setCurrentIndex(index);
        setClickedImg(item);
    };

    const handelRotationRight = () => {
        const totalLength = currentImageList.length;
        if (currentIndex + 1 >= totalLength) {
            setCurrentIndex(0);
            const newUrl = currentImageList[0];
            setClickedImg(newUrl);
            return;
        }
        const newIndex = currentIndex + 1;
        const newUrl = currentImageList.filter((item) => {
            return currentImageList.indexOf(item) === newIndex;
        });
        const newItem = newUrl;
        setClickedImg(newItem);
        setCurrentIndex(newIndex);
    };

    const handelRotationLeft = () => {
        const totalLength = currentImageList.length;
        if (currentIndex === 0) {
            setCurrentIndex(totalLength - 1);
            const newUrl =  currentImageList[totalLength-1];
            setClickedImg(newUrl);
            return;
        }
        const newIndex = currentIndex - 1;
        const newUrl = currentImageList.filter((item) => {
            return currentImageList.indexOf(item) === newIndex;
        });
        const newItem = newUrl[0];
        setClickedImg(newItem);
        setCurrentIndex(newIndex);
    };

    return (
        <>
            <div>
                {/* {images.data.map((item, index) => (
                    <div key={index} className="wrapper-images">
                        <img
                            src={item.link}
                            alt={item.text}
                            onClick={() => handleClick(item, index)}
                        />
                        <h2>{item.text}</h2>
                    </div>
                ))} */}
                <ul className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
                    {
                        currentImageList == null ? "" :
                            currentImageList.map((object, index) => (
                                <li className="relative" key={index}>
                                    <div key={index} className="wrapper-images group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden">
                                        <img src={object} alt="" className="object-cover pointer-events-none group-hover:opacity-75" />
                                        <button type="button" className="absolute inset-0 focus:outline-none" onClick={() => handleClick(object, index)}>
                                        </button>
                                    </div>
                                </li>
                            ))
                    }
                </ul>
                <div>
                    {clickedImg && (
                        <Modal
                            clickedImg={clickedImg}
                            handelRotationRight={handelRotationRight}
                            setClickedImg={setClickedImg}
                            handelRotationLeft={handelRotationLeft}
                        />
                    )}
                </div>
            </div>
        </>
    );
}